import React, { useState } from "react";
import Button from "../button/Button";

import img from "../../assets/images/layouts/create.png";
import logo from "../../assets/images/logo/logo.png";

function Create(props) {
  const [dataBlock] = useState({
    heading: "Start Earning while playing.",
    desc: "Get udpated with news, tips & tricks",
  });
  return (
    <section className="create ">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="create__main ">
              <div className="content ">
                <h4 className="heading">{dataBlock.heading}</h4>
                <p>{dataBlock.desc}</p>
                <Button title="Join Now" link="/signup" />
              </div>
              <img
                src={logo}
                style={{ height: "450px" }}
                // "https://cyfoniireact-eb8gshhgc-themesflat.vercel.app/static/media/create.cd5fb5a8c6939f44c135.png"
                alt="Cyfonii"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    // <section className="create ">
    //   <div className="container">
    //     <div className="row">
    //       <div className="col-12" style={{ background: "blue" }}>
    //         <div className="create__main " style={{ background: "blue" }}>
    //           <div className="content ">
    //             <h4 className="heading">{dataBlock.heading}</h4>
    //             <p>{dataBlock.desc}</p>
    //             <Button title="Join Now" link="/signup" />
    //           </div>
    //           <img
    //             src="https://cyfoniireact-eb8gshhgc-themesflat.vercel.app/static/media/create.cd5fb5a8c6939f44c135.png"
    //             alt="Cyfonii"
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
}

export default Create;
